import { getResourceTo } from 'react/utils/utils';

export const getFormFields = () => (
  {
    name: getResourceTo('externalstorage.name'),
    ftpHost: getResourceTo('externalstorage.ftphost'),
    ftpType: getResourceTo('externalstorage.ftptype'),
    ftpPort: getResourceTo('externalstorage.ftpport'),
    ftpUser: getResourceTo('externalstorage.ftpuser'),
    ftpPass: getResourceTo('externalstorage.ftppass')
  }
);
